<template>
  <div :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
  <mt-swipe class="swipper-wrapper" v-bind:style="getBannerStyle" :showIndicators="isShowIndicators">
    <mt-swipe-item v-for="index in editablePageConfig.editable_page_config_content.image[0].count" :key="index">
      <div class="swipper-item" :style="Object.assign({},getBannerStyle,{backgroundImage:'url('+editablePageConfig.editable_page_config_content.image[0].list[index-1].path+')'})" v-if='editablePageConfig.editable_page_config_content.image[0].list[index-1]' @click="goAdUrl(editablePageConfig.editable_page_config_content.link[0].list[index-1].content)"></div>
      <div class="swipper-item" :style="getBannerStyle" style="background-image:url(../../../../assets/image/home/default_image_banner.png)" v-else></div>
    </mt-swipe-item>
  </mt-swipe>
  </div>
</template>

<script>
export default {
  name: 'Model1',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {
    getBannerStyle: function () {
      let itemWidth = this.editablePageConfig.editable_page_config_content.width
      let itemHeight = this.editablePageConfig.editable_page_config_content.height
      return {
        width: itemWidth,
        height: itemHeight
      }
    },
    isShowIndicators () {
      if (this.editablePageConfig.editable_page_config_content.image[0].count) {
        return true
      }
      return false
    }
  },
  methods: {
    goAdUrl (url) {
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.swipper-wrapper{margin: 0 auto}
  .swipper-item{background-size:cover;background-repeat: no-repeat;background-position: center}
</style>
